import core from './core'
import cart from './cart'
import docs from './document'
import entity from './entity'
import browser from './browser'

export default {
  ...core, ...cart, ...docs, ...entity, ...browser
}
